import { Component, OnInit, Input, ViewChild, ElementRef } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser"; // Import from platform-browser
import { MatTableDataSource } from "@angular/material";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import * as moment from "moment/moment";
import { Router, ActivatedRoute } from "@angular/router";
import { first } from "rxjs/operators";
import { FileService } from "src/app/shared/services/file.service";
import * as _ from "lodash";
import { MatSnackBar } from "@angular/material";
import choice from "../../../../../../shared/choices";

import { ApirequestService } from "../../../../../../shared/services/apirequest.service";
import { AlertService } from "../../../../../../shared/services/alert.service";
import { CustomSnackBarComponent } from "../../../../../../shared/common/custom-snack-bar/custom-snack-bar.component";

import { MatDialog } from "@angular/material/dialog";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { AngularEditorConfig } from "@kolkov/angular-editor";
import { RepositorySharedService } from "../../../study-evidence/form/repository-shared-service/repository-shared.service";
import { StudiesSharedService } from "../../../measures/measure-form/studies-shared-service/studies-shared.service";
import { StudiesDialogComponent } from "../../../measures/measure-form/studies-dialog/dialog.component";

@Component({
  selector: "app-interventions-single-upload",
  templateUrl: "./interventions-single-upload.component.html",
  styleUrls: ["./interventions-single-upload.component.css"],
})
export class InterventionsSingleUploadComponent implements OnInit {
  loading: boolean;
  start_date: string = "";
  end_date: string = "";
  url: string;
  topHeaders: string[] = ["channelGrouping", "acquisition", "behavior"];
  displayedColumns: string[] = [
    "totalUsers",
    "usersWhoEngagedWithPlatform",
    "newUsers",
    "sessions",
    "avgSessionDuration",
    "bounceRate",
  ];
  alldisplayedColumns: string[] = [
    "channelGrouping",
    "totalUsers",
    "usersWhoEngagedWithPlatform",
    "newUsers",
    "sessions",
    "avgSessionDuration",
    "bounceRate",
  ];

  filterConfigs = [
    {
      url: "interventions/type/",
      targetProperty: "inteventionTypesFilter",
      key: "intervention_type",
      label: "Intervention Type",
      selected: "selectedType",
    },
    {
      url: "interventions/delivery-mode/",
      targetProperty: "deliveryModeFiltersList",
      key: "delivery_mode",
      label: "Delivery Mode",
      selected: "selectedDeliveryMode",
    },
    {
      url: "interventions/settings/",
      targetProperty: "settingFiltersList",
      key: "setting",
      label: "Setting",
      selected: "selectedSetting",
    },
    {
      key: "session_duration",
      label: "Session Duration",
      url: "interventions/session/",
      targetProperty: "sessionFiltersList",
      selected: "selectedSessionDuration",
    },
    {
      key: "total_duration",
      label: "Total Duration",
      url: "interventions/duration/",
      targetProperty: "durationFiltersList",
      selected: "selectedTotalDuration",
    },
    {
      key: "session_frequency",
      label: "Frequency Of Sessions",
      url: "interventions/session-frequency/",
      targetProperty: "sessionFrequencyFiltersList",
      selected: "selectedSessionFrequency",
    },
    {
      key: "target_mechanism",
      label: "Target Mechanism",
      url: "interventions/target-mechanism/",
      targetProperty: "targetMechanismFiltersList",
      selected: "selectedTargetMechanism",
    },
    {
      key: "target_behavior",
      label: "Target Behaviour",
      url: "interventions/target-behaviour/",
      targetProperty: "targetBehaviorFiltersList",
      selected: "selectedTargetBehaviour",
    },
  ];

  inteventionTypesFilter = [];
  deliveryModeFiltersList = [];
  settingFiltersList = [];
  sessionFiltersList = [];
  durationFiltersList = [];
  sessionFrequencyFiltersList = [];
  targetMechanismFiltersList = [];
  targetBehaviorFiltersList = [];

  selectedType: string;
  selectedDeliveryMode: string;
  selectedSetting: string;
  selectedSessionDuration: string;
  selectedTotalDuration: string;
  selectedSessionFrequency: string;
  selectedTargetMechanism: string;
  selectedTargetBehaviour: string;

  dataSource: MatTableDataSource<any>;
  choices = choice;

  selectedUploadedBy: string;
  searchTerm: string;
  selectedStatus: string;
  selectedStudies: any[];
  selectedShortDescription: any;

  filter_url = {};
  page: number;
  total: number;
  page_size: number;
  total_pages: number;
  intervention_id: string;

  interventions: any[];

  items = ["All", "Pending", "Published", "Draft"];
  // activeIndex: number | null = null;
  activeIndex: number = 0; // Set default to 0 (first item)
  interventionForm: FormGroup;
  formSubmitted: boolean;
  loadedIntervention: any;
  isNewIntervention: boolean;
  submitted: boolean;
  @Input() id: string;
  studyReceivedData: any;
  interventionOwnerId: string;
  user_id: string;
  isInterventionOwner: boolean;
  isAdmin: boolean;
  loggedInUser: any;
  @Input() sourceData: any;

  /*WYSWYG from the links below:
  https://www.npmjs.com/package/@kolkov/angular-editor
    https://stackblitz.com/edit/angular-editor-wysiwyg?file=src%2Fapp%2Fapp.component.ts
  both refer to the same thing, second one is very clear
  */
  shortDescriptionHtmlContent = "";
  longDescriptionHtmlContent = "";

  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "15rem",
    minHeight: "5rem",
    placeholder: "Max 150 characters",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  config2: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: "7.5rem",
    minHeight: "2.5rem",
    placeholder: "Max 150 characters",
    translate: "no",
    defaultParagraphSeparator: "p",
    defaultFontName: "Arial",
    customClasses: [
      {
        name: "quote",
        class: "quote",
      },
      {
        name: "redText",
        class: "redText",
      },
      {
        name: "titleText",
        class: "titleText",
        tag: "h1",
      },
    ],
  };

  constructor(
    private apirequestService: ApirequestService,
    private router: Router,
    private fileService: FileService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public snackBar: MatSnackBar,
    public alertService: AlertService,
    public dialog: MatDialog,
    private modalService: NgbModal,
    private studiesSharedService: StudiesSharedService,
    private repositorySharedService: RepositorySharedService
  ) {}

  onSubmit(publish: any) {
    this.formSubmitted = true;

    let interventionData = this.interventionForm.value;

    console.log(interventionData);

    if (this.interventionForm.valid) {
      this.formSubmitted = false;
      console.log(interventionData);

      this.submitted = true;
      if (this.interventionForm.invalid) {
        return;
      }
      this.loading = true;
      let theForm = this.interventionForm.value;
      theForm.short_description = this.shortDescriptionHtmlContent;
      theForm.long_description = this.longDescriptionHtmlContent;

      this.filterConfigs.forEach((config) => {
        try {
          if (theForm[config.key]) {
            theForm[config.key] = theForm[config.key]
              .split(",")
              .map((item) => ({ id: item.trim() }));
          }
        } catch (e) {}
      });

      try {
        let s = [];
        this.selectedStudies.forEach((curr) => s.push(curr.id));
        theForm.study_evidences = s;
      } catch (e) {}

      console.log(`theForm=${JSON.stringify(theForm)}`);
      if (
        this.interventionForm.get("id").value === ""
      ) {
        console.log("Calling create");
        if (this.interventionForm.get("access_intervention_button").value === "") {
          this.alertService.error(400, "Access Intervention Button is required");
          this.loading = false;
          return;
        } else {
          const url = "interventions/create/details/";
          this.apirequestService
            .post(url, theForm)
            .pipe(first())
            .subscribe(
              (data) => {
                this.intervention_id = data.id;
                this.snackBar.openFromComponent(CustomSnackBarComponent, {
                  data: {
                    message: "Intervention Details saved",
                    action: "Success",
                  },
                  duration: 3 * 1000,
                  panelClass: ["transparent-snack-bar"],
                });
                this.loading = false;
                this.formSubmitted = false;
                if (publish == true) {
                  theForm.publish = true;
                  this.sendForReview("Reviewing Scientist");
                } else if (publish == false) {
                  theForm.publish = false;
                }
                this.getFormData();

                if (this.sourceData != undefined) {
                  this.repositorySharedService.sendData(data);
                  let dialogRef = this.sourceData.dialogRef;
                  dialogRef.close();
                }
                this.attachStudyToIntervention(data);
                this.router.navigate([
                  "/dashboard/interventions/form/" + this.intervention_id,
                ]);
              },
              (error) => {
                this.alertService.error(
                  error,
                  "Intervention with the details you provided exists."
                );
                this.loading = false;
              }
            );
        }
      } else {
        console.log("Calling update");
        const url = "interventions/update/details/";
        this.apirequestService
          .post(url, theForm)
          .pipe(first())
          .subscribe(
            (data) => {
              this.snackBar.openFromComponent(CustomSnackBarComponent, {
                data: {
                  message: "Intervention`s Details successfully updated",
                  action: "Success",
                },
                duration: 3 * 1000,
                panelClass: ["transparent-snack-bar"],
              });
              this.loading = false;
              this.formSubmitted = false;
              this.attachStudyToIntervention({
                id: this.intervention_id,
                title: theForm.title,
              });
            },
            (error) => {
              this.alertService.error(error, error.message);
              this.loading = false;
            }
          );
      }
    }
  }

  onSubmit2(publish: any) {
    this.formSubmitted = true;
    let interventionData = this.interventionForm.value;
    console.log(interventionData);

    if (this.interventionForm.valid) {
      this.formSubmitted = false;
      console.log(interventionData);

      this.submitted = true;
      if (this.interventionForm.invalid) {
        return;
      }
      this.loading = true;
      let theForm = this.interventionForm.value;
      theForm.id = this.intervention_id;
      theForm.short_description = this.shortDescriptionHtmlContent;
      theForm.long_description = this.longDescriptionHtmlContent;

      this.filterConfigs.forEach((config) => {
        try {
          if (theForm[config.key]) {
            theForm[config.key] = theForm[config.key]
              .split(",")
              .map((item) => ({ id: item.trim() }));
          }
        } catch (e) {}
      });

      try {
        let s = [];
        this.selectedStudies.forEach((curr) => s.push(curr.id));
        theForm.study_evidences = s;
      } catch (e) {}

      console.log(`theForm=${JSON.stringify(theForm)}`);

      console.log("Calling update");
      const url = "interventions/update/details/";
      this.apirequestService
        .post(url, theForm)
        .pipe(first())
        .subscribe(
          (data) => {
            this.snackBar.openFromComponent(CustomSnackBarComponent, {
              data: {
                message: "Intervention`s Details successfully updated",
                action: "Success",
              },
              duration: 3 * 1000,
              panelClass: ["transparent-snack-bar"],
            });
            this.loading = false;
            this.formSubmitted = false;
            if (publish == true) {
              theForm.publish = true;
              this.sendForReview("Reviewing Scientist");
            } else if (publish == false) {
              theForm.publish = false;
            }
            if (this.sourceData != undefined) {
              this.studiesSharedService.sendData(data);
              let dialogRef = this.sourceData.dialogRef;
              dialogRef.close();
            }
            this.attachStudyToIntervention({
              id: this.intervention_id,
              title: theForm.title,
            });
          },
          (error) => {
            this.alertService.error(error, error.message);
            this.loading = false;
          }
        );
    }
  }

  private getFormData() {
    if (this.id != "" || this.id != undefined) {
      console.log("^^^^^^^^^^^^^^^", this.id);

      this.isNewIntervention = false;
      const url = "interventions/details/details/" + this.id + "/";
      var can_edit_ = false;
      this.apirequestService.get(url).subscribe(
        (res) => {
          this.intervention_id = this.id;
          this.interventionForm.patchValue(res, { onlySelf: true });
          this.interventionForm.patchValue({
            id: this.intervention_id,
          });
          this.filterConfigs.forEach((config) => {
            try {
              this[config.selected] =
                res[config.key] && res[config.key][0]
                  ? res[config.key][0].id
                  : null;
            } catch (e) {}
          });
          try {
            this.selectedStudies = res.study_evidences;
          } catch (e) {}
          try {
            this.shortDescriptionHtmlContent = res.short_description;
          } catch (e) {}
          try {
            this.longDescriptionHtmlContent = res.long_description;
          } catch (e) {}
          try {
            this.interventionOwnerId = res.researcher.id;
          } catch (e) {}

          this.interventionForm.patchValue({
            format: res.format,
          });
          this.interventionForm.patchValue({
            stage: "Identified",
          });

          if (this.user_id == this.interventionOwnerId) {
            this.isInterventionOwner = true;
          }

          console.log(
            `this.interventionForm.=${JSON.stringify(
              this.interventionForm.value
            )}`
          );
          this.loadedIntervention = res;
          var user_ = JSON.parse(localStorage.getItem("auth.user"));
          if (
            res.researcher.id == user_["id"] ||
            user_["role"] == "Admin" ||
            user_["role"] == "System Admin"
          ) {
            can_edit_ = true;
          } else {
            res.co_owners.forEach(function (co_owner) {
              if (co_owner["id"] == user_["id"]) {
                can_edit_ = true;
              }
            });
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  ngOnInit() {
    // let today = new Date();
    this.isNewIntervention = true;
    this.submitted = false;
    this.page = 1;
    this.total = 0;
    this.page_size = 20;
    this.searchTerm = "";
    this.selectedType = "All";
    this.selectedDeliveryMode = "All";
    this.selectedSetting = "All";
    this.selectedSessionDuration = "All";
    this.selectedTotalDuration = "All";
    this.selectedSessionFrequency = "All";
    this.selectedTargetMechanism = "All";
    this.selectedTargetBehaviour = "All";
    this.selectedUploadedBy = "All";
    this.selectedStatus = "All";
    this.selectedStudies = [];
    let user = JSON.parse(localStorage.getItem("auth.user"));
    this.loggedInUser = user;
    this.user_id = user.id;
    if (user.role == "Admin") {
      this.isAdmin = true;
    } else {
      this.isAdmin = false;
    }

    this.studiesSharedService.data$.subscribe((data) => {
      if (data != undefined) {
        console.log(`data=${JSON.stringify(data)}`);
        this.studyReceivedData = data;
        console.log(
          `studyReceivedData=${JSON.stringify(this.studyReceivedData)}`
        );

        this.selectedStudies.push({
          id: this.studyReceivedData.id,
          title: this.studyReceivedData.title,
        });
      }
    });

    this.getFilters();
    this.createForm();
    if (this.id != "" || this.id != undefined) {
      this.getFormData();
    }
  }

  createForm() {
    this.interventionForm = this.fb.group({
      id: "",
      title: ["", Validators.required],
      stage: "Identified",
      short_description: ["", Validators.required],
      format: ["", Validators.required],
      google_scholar_link: "",
      long_description: ["", Validators.required],
      citations: "",
      study_evidences: [[]],
      intervention_type: [[]],
      delivery_mode: [[]],
      setting: [[]],
      session_duration: [[]],
      total_duration: [[]],
      session_frequency: [[]],
      target_mechanism: [[]],
      target_behavior: [[]],
      access_intervention_button: "",
    });
  }

  getFilters() {
    this.filterConfigs.forEach((config) => {
      this.apirequestService.get(config.url).subscribe(
        (res) => {
          this[config.targetProperty] = res.results;
        },
        (error) => {
          console.log(`Error fetching ${config.url}:`, error);
        }
      );
    });
  }

  onSelectChange(item_name: string, event: any) {
    const selectedValue = event.target.value;
    const config = this.filterConfigs.find(
      (filter) => filter.key === item_name
    );
    if (config && config.selected) {
      this[config.selected] = selectedValue;
    }
    if (item_name == "uploaded_by") {
      this.selectedUploadedBy = selectedValue;
    }
  }

  formatDate(inputDate) {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const paddedDay = day < 10 ? "0" + day : day;
    const paddedMonth = month < 10 ? "0" + month : month;
    return `${paddedDay}/${paddedMonth}/${year}`;
  }

  isOdd(num: number): boolean {
    return num % 2 !== 0;
  }

  isMultipleOf4(number) {
    return number % 4 === 0;
  }
  filter_data() {}

  handleClick(index: number) {
    this.activeIndex = index;
    this.selectedStatus = this.items[index];
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(StudiesDialogComponent, {
      // width: '250px'
      width: "300%",
      height: "2500px",
      data: { sourceData: { source: "intervention_form", source_id: this.id } },
    });
    // After the dialog has been opened, let us update the data object
    dialogRef.componentInstance.data.sourceData.dialogRef = dialogRef;

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }

  attachStudyToIntervention(intervention: any) {
    console.log("ADD CLICKED");
    this.repositorySharedService.sendData(intervention);
    let dialogRef = this.sourceData.dialogRef;
    dialogRef.close();
  }

  removeStudy(study: any) {
    this.selectedStudies = this.selectedStudies.filter(
      (item) => item !== study
    );
  }

  loadExternalScript(url: string): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const scriptElement = document.createElement("script");
      scriptElement.src = url;
      scriptElement.onload = () => {
        resolve();
      };
      scriptElement.onerror = (error) => {
        reject(error);
      };
      document.body.appendChild(scriptElement);
    });
  }

  sendForReview(destination) {
    if (this.intervention_id != undefined) {
      this.formSubmitted = true;
      this.formSubmitted = false;
      const data = {
        intervention_id: this.intervention_id,
      };
      const url = "interventions/submit_for_approval/";
      this.formSubmitted = true;
      this.apirequestService
        .post(url, data)
        .pipe(first())
        .subscribe(
          (data) => {
            this.id = data.id;
            this.snackBar.openFromComponent(CustomSnackBarComponent, {
              data: {
                message: data,
                action: "Success",
              },
              duration: 3 * 1000,
              panelClass: ["transparent-snack-bar"],
            });
            this.formSubmitted = false;
            this.attachStudyToIntervention({ id: this.intervention_id });
            this.router.navigate([
              "/dashboard/interventions/form/" + this.intervention_id,
            ]);
          },
          (error) => {
            this.alertService.error(error, "");
            this.formSubmitted = false;
          }
        );
    }
  }

  onUploadedFile(data) {
    this.interventionForm
      .get("access_intervention_button")
      .setValue(data.file_path);
  }
}
